import React from 'react';
import { Box} from '@mui/material';


export default function PageError(){
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'top',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '100vh',
                marginTop:'10vh'
            }}
        >
            <div className="page-has-error">
                <p className="heading">Oops..<br/>something went wrong</p>
            <div className="gears">
                <div className="gear one">
                    <div className="bar"/>
                    <div className="bar"/>
                    <div className="bar"/>
                </div>
                <div className="gear two">
                    <div className="bar"/>
                    <div className="bar"/>
                    <div className="bar"/>
                </div>
                <div className="gear three">
                    <div className="bar"/>
                    <div className="bar"/>
                    <div className="bar"/>
                </div>
            </div>
            </div>
        </Box>
    )
}